import { OpenPanel } from '@openpanel/web';

let op = null;

// Initialize OpenPanel analytics once for the whole app.
// Loads only when REACT_APP_OPENPANEL_CLIENT_ID is set (e.g. in Vercel env vars).
// trackScreenViews hooks into history.pushState/popstate, so React Router
// navigations are recorded as screen views automatically.
export const initOpenPanel = () => {
  const clientId = process.env.REACT_APP_OPENPANEL_CLIENT_ID;
  if (op || !clientId || typeof window === 'undefined') {
    return op;
  }

  try {
    op = new OpenPanel({
      clientId,
      apiUrl: 'https://app.tidemetric.com/api',
      trackScreenViews: true,
      trackOutgoingLinks: true,
      trackAttributes: true,
    });
  } catch (error) {
    console.error('OpenPanel initialization error:', error);
  }

  return op;
};

export const getOpenPanel = () => op;
